<template>
  <div class="cardView" >
    <div class="cardView-body">
      <a-card hoverable  class="card"  v-for="(list,index) in contributeList" :style="{width:cardWidth}">
        <div  class="card-item">
          <div style="flex: 1">
            <img class="card-img" :src="list.coverImg" alt="">
          </div>

          <div style="width: 70%;margin-left: 10px">
            <div class="card-item-title" :title="list.name">
              {{list.name}}
            </div>
            <div style="color: #999999;margin: 3px 0;font-size: small;">
              类型：
              <span v-for="(item,itemIndex) in list.coursewareType">
                {{item==='video'?'视频':item==='file'?'文件':''}}
                <span v-if="itemIndex!==list.coursewareType.length-1">/</span>
              </span>
            </div>
            <div style="display: flex;flex-wrap: wrap">
              <div class="btn" style="margin-right: 10px;" @click="tougaoModel(list)" >
                查看介绍
              </div>
              <div @click="tougaoBtn(list)"  class="btn"  style="color: white;background: #1890ff">
                参加投稿
              </div>
            </div>
          </div>
        </div>
      </a-card>
      <i :style="{'--cardWidth': cardWidth}"></i><i :style="{'--cardWidth': cardWidth}"></i><i :style="{'--cardWidth': cardWidth}"></i>
    </div>
    <a-modal
        :footer="null"
        :visible="visible"
        width="800px"
        @cancel="()=>{this.visible = false;}"
    >
      <div>
        <div style="text-align: center;margin-bottom: 20px"><h3>{{ itemTitle }}</h3></div>

        <div v-html="itemContent" class="textSty">
        </div>
      </div>
    </a-modal>
    <Login :loginVisible="loginVisible" @loginCancel="loginCancel"></Login>
  </div>
</template>

<script>
import {getUserInfo} from "@/util/userInfo";
import Login from "@/components/login.vue";

export default {
  name: "contributeView",
  components: {Login},
  props: {
    contributeList:{
      type:Array,
      default:[]
    },
    cardWidth:{
      type:String,
      default:'23%'
    }
  },
  data(){
    return{
      visible:false,
      loginVisible: false,
      token: window.localStorage.getItem("user_info")?JSON.parse(window.localStorage.getItem("user_info")).id:"",
      itemContent:'',
      itemTitle:'',
    }
  },
  mounted() {
  },
  methods:{
    tougaoModel(items){
      this.visible = true
      this.itemTitle = items.name
      this.itemContent =  items.introduceMarkdown
    },
    tougaoBtn(item){
      if (this.token === null || this.token === '' || !this.token) {
        this.loginVisible = true
      } else {
        this.$store.state.contributeItem=item
        this.$store.state.contributeType=0
        this.$router.push({name:'Contribute'})
      }
    },
    loginCancel() {// 登录窗口关闭
      this.loginVisible = false
    },

  }

}
</script>

<style scoped>
.cardView {
  width: 100%;
  display: inline-block;
}
.cardView-body{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%
}
.card{
  float: left;
  /*margin-left: 1%;*/
  /*margin-right: 1%;*/
  margin-bottom: 2%;
  /*width:25%;*/
  min-height: 100px;
}
.cardView-body>i {
  width: var(--cardWidth);
}

/*.card:nth-child(4n){*/
/*  margin-right: auto;*/
/*}*/
::v-deep .ant-card-body{
  padding: 10px;
}
.card-item{
  width: 100%;
  height: 100%;
  display: flex;
}


.card-img{
  width: 100%;
  /*height: 100%;*/
}
.card-item-title{
  font-weight: bold;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.textSty {
  line-height: 1.5;
  text-indent: 2em;
  margin-bottom: 6px;
}
.btn{
  display: flex;
  align-items: center;
  height: 25px;
  padding: 0 4px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.btn:hover{
  border-color: #1890ff;
  color: #1890ff;
}

</style>